import { LoginUserService } from "./../core/services/login-user.service";
import { OAuthService } from "./oauth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-oauth",
  template: `<div class="main-container">跳转中，请稍等...</div> `,
  styles: [
    `
      .main-container {
        color: #5555ff;
      }
    `,
  ],
  providers: [OAuthService],
})
export class OAuthComponent implements OnInit {
  constructor(
    private router: Router,
    private activedRoute: ActivatedRoute,
    private oauthService: OAuthService,
    private _login: LoginUserService
  ) {
    this.activedRoute.queryParams.subscribe((res) => {
      const { token } = res;
      if (token) {
        // 发起请求
        console.log(token);
        this.oauthService.authorize(token).subscribe(
          (resp) => {
            if (resp["data"]) {
              let obj = resp["data"]["user"];
              if (obj["type"] === 3) {
                obj["company_id"] = obj["userInfo"]["id"];
                obj["logo"] = obj["userInfo"]["logo"];
              } else if (obj["type"] === 1) {
                obj["student_id"] = obj["userInfo"]["id"];
                //获取学生简历id
                obj["resume_id"] = obj["userInfo"]["resume_id"];
                obj["headimg"] = obj["userInfo"]["headimg"];
              }
              if (resp["data"]["uchead"]) {
                obj["uchead"] = resp["data"]["uchead"];
              }
              delete obj["userInfo"];
              console.log('testssssss', obj)
              let a = this._login.setLogin(obj);
              if (a) {
                //是否第一次登录，或信息是否完善判断函数
                this.isFirstLogin(this._login.isFistLogin());
              }
            }
          },
          (error) => {
            console.error(error);
            this.router.navigate(["/"]);
          }
        );
      } else {
        this.router.navigate(["/"]);
      }
    });
  }
  isFirstLogin(cc) {
    //判断处理
    if (cc) {
      // 是第一次登录  跳转到完善信息页面
      this.router.navigate(["/user-info/user-complete"]);
    } else {
      // 不是第一次登录  跳转到主页面 或  登录时当前页
      // this.router.navigate(["/"]);
      window.location.href = '/';
    }
  }
  ngOnInit() {}
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/oauth/oauth.component.ts